
  import { Options, Vue } from 'vue-class-component';   
  import Common from '@/services/common.js';  
  import $ from 'jquery';  
  import 'bootstrap'; 
  import Basic from '@/components/Basic.vue';    
  import Axios from "axios";
  @Options({
    components: {  
      Basic
    }, 
  })

  export default class ThirdWaveAccessMenuPage extends Vue { 
    third_wave_token: any = ''; 
    STORAGE_KEY = "caprock-local";   
    prev_path :any = ''; 
    
     checkTokenValidity(token:string){ 
        let form_data = new FormData();
        form_data.append('token', token); 
        Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
        Axios.post(`${Common.base_url()}check-token-access`, form_data, {
          headers: {  
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => { 
          localStorage.setItem(
            this.STORAGE_KEY, JSON.stringify({
              'access-token':response.data.user_token,
              'user_info'   :response.data.user_info,
              'popup'       :response.data.check_popup,
            })
          ); 
          localStorage.setItem(
            'system_access' , response.data.access
          ); 
          
          localStorage.setItem('profile_url',  response.data.user_info.profile_url); 
          localStorage.setItem('merchant_logo',  response.data.merchant_logo); 
          localStorage.setItem('merchant_version',  response.data.merchant_version); 
          
          if(response.data.access==1){
            if(typeof(this.prev_path)!=='undefined' && this.prev_path!='' && this.prev_path!=null){ 
              this.$router.push(this.prev_path); 
            }else{ 
              this.$router.push('/'); 
            }  
          }else{
            if(response.data.user_info['user_type']==1){
              // this.$router.push('/individual-app');  
              this.$router.push('/onboard');  
            }else{
              // this.$router.push('/corporate-app');  
              this.$router.push('/onboard');  
            } 
          }
        })
        .catch(error => {
          console.error('Error checking token:', error);
        });
    } 


    created() {      
      Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
      document.title = 'Accessing onboarding application || Caprock Merchant Platform';
      if (this.$route && this.$route.params && this.$route.params.id) {
        const idParam = this.$route.params.id;
        this.checkTokenValidity(idParam as string)
      }
    }
     
     
  } 
